import * as Sentry from '@sentry/sveltekit';
import {captureConsoleIntegration, extraErrorDataIntegration, replayIntegration} from '@sentry/sveltekit';
import * as SentryCapacitor from '@sentry/capacitor';
import {initMatomo} from '$lib/third-party/matomo.js';
import {Capacitor} from '@capacitor/core';

// NOTE kept Sentry init here because of SSR import errors from '@sentry/sveltekit'
// 'hooks.client' only client --> no SSR problems
const sentryOptions = {
    dsn: 'https://aa3d8f8497c3d8bd9eb25ffabaecad26@monitor.vocabeo.com/2',
    tunnel: 'https://monitor.vocabeo.com/tunnel',
    tracesSampleRate: 1,
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1,
    integrations: [
        replayIntegration({
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
        }),
        captureConsoleIntegration({levels: ['error']}),
        extraErrorDataIntegration(),
    ],
    ignoreErrors: [
        /^true$/,
        /^t.\$_Tawk.i18next is not a function$/,
        /^i.a.logger is undefined$/,
    ],
}

const platform = Capacitor.getPlatform()
const sentryInstance = platform === 'web' ? Sentry : SentryCapacitor

const dev = import.meta.env.DEV
const disabledViaLocalStorage = localStorage.getItem('disableScripts') !== null
const enabledViaLocalStorage = localStorage.getItem('enableScripts') !== null

if ((dev || disabledViaLocalStorage) && !enabledViaLocalStorage) {
    console.warn('### HOOKS third-party scripts disabled via ' + (dev ? 'DEV MODE' : 'localStorage'))
} else {
    if (platform === 'web') {
        Sentry.init(sentryOptions)
    } else {
        SentryCapacitor.init(sentryOptions, Sentry.init)
    }
    sentryInstance.setTag('capacitor_platform', platform);

    initMatomo()
    // NOTE initialize Tawk in +layout.svelte since yOffset stopped working when run inside function from here...
}

export const handleError = async ({error, event, status, message}) => {
    // NOTE error in load function will fall back to +error.svelte and no error was logged (e.g. legal pages)
    //  >> log here to send to sentry
    console.error('ERROR', error)
    // console.log('event >>>', event)
    // console.log('status >>>', status)
    // console.log('message >>>', message)

    // TODO what's the errorId about? To find the session in Sentry..?!
    // const errorId = crypto.randomUUID(); //NOTE might not work on android mobile
    // console.log('handleError >>>', error.message)

    return {
        message: 'Something went wrong on our end. Please try again later or contact support@vocabeo.com if the problem persists.',
    };
};